// extracted by mini-css-extract-plugin
module.exports = {"label":"selected-label-module--label--3UMB7","text":"selected-label-module--text--1W9Xk","textItem":"selected-label-module--textItem--2pxEl"};